import { UserRound } from 'lucide-react';
import { Button, Card, Container, Spinner } from '@/components/ui';
import { useAuth } from '@/app/providers/AuthProvider';
import { useAuthModal } from '@/features/auth/authModalStore';
import { ProfileWorkspace } from './components/ProfileWorkspace';

/**
 * Self profile (`/me`). Reads the live `profiles` row from AuthProvider and
 * renders the full-screen three-panel workspace (Locker · edit · public
 * reflection). Logged out → the OG `_v19` "Claim your profile" gate.
 */
export function ProfilePage() {
  const { profile, loading } = useAuth();
  const { openAuth } = useAuthModal();

  return (
    <Container className="mx-auto -mt-8 max-w-[1760px]">
      {loading ? (
        <div className="flex justify-center py-24">
          <Spinner />
        </div>
      ) : profile ? (
        <ProfileWorkspace profile={profile} />
      ) : (
        <Card className="mx-auto flex max-w-lg flex-col items-center gap-4 p-10 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-soft text-accent">
            <UserRound size={22} />
          </div>
          <div>
            <div className="text-lg font-extrabold text-hi">Claim your profile</div>
            <p className="mx-auto mt-1 max-w-md text-sm text-mid">
              Set your title, pick an emblem, link your socials, and stamp your identity across
              WINR.
            </p>
          </div>
          <Button onClick={openAuth}>Log in</Button>
        </Card>
      )}
    </Container>
  );
}
